var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{class:['routine-footer', { 'desktop': !_vm.isMobile }],attrs:{"fixed":""}},[_c('div',{staticClass:"rf-inner"},[_c('div',{staticClass:"rf-pct"},[_vm._v(_vm._s(_vm.percent)+"%")]),_c('div',{staticClass:"rf-bar"},[_c('div',{staticClass:"rf-fill",style:({ width: `${_vm.percent}%` })})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }